export default __webpack_public_path__ + "img/eTTjHEMo.cee6f18b.svg";